var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5h2.5m2.5 0h-2.5m0 0V9m0 2.5V14",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1v3M11 1v3",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H2",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7 12.8V3.2h10.6v3.402h1.2V2.8a.8.8 0 00-.8-.8H2.3a.8.8 0 00-.8.8v10.4a.8.8 0 00.8.8H8v-1.2H2.7z",
    fill: "#7D8085"
  })));
}
export default __webpack_public_path__ + "static/addCalendar.282d159a.svg";
export { SvgAddCalendar as ReactComponent };